import React, { useState } from "react";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";

const PrintButton = ({ search, filters }) => {
    const [loading, setLoading] = useState(false);

    const handlePrint = () => {
        const params = {
            search: search,
            clinics: filters.clinics,
            category: filters.category,
            brand: filters.brand,
            model: filters.model,
        }
        
        setLoading(true);
        axiosInstance.get("/equipment/inventory/print", { params, responseType: "blob" })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            //get file name from response headers
            link.setAttribute(
                "download",
                response.headers["content-disposition"].split("filename=")[1]
            );

            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link); // Clean up
            window.URL.revokeObjectURL(url); // Free up resources
        })
        .catch((error) => {
            console.error("Error printing:", error);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
        <Button
            type="primary"
            size="large"
            className="ml-2"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint()}
            loading={loading}
        >
            Print
        </Button>
    )
};

export default PrintButton;